module.exports = __webpack_public_path__ + "img/header1.d539c7f7.png";